import type { DiaMare, DiaMareInterpretado } from '@/types/mare';

export function clampMes(mes: number, padrao = 1): number {
  if (!Number.isFinite(mes)) return padrao;
  return Math.max(1, Math.min(12, mes));
}

export function clampDia(dia: number, mes: number, ano: number, padrao = 1): number {
  if (!Number.isFinite(dia)) return padrao;
  const ultimoDia = new Date(ano, mes, 0).getDate();
  return Math.max(1, Math.min(ultimoDia, dia));
}

export function getHojeBrasil(): Date {
  const now = new Date();
  const brasilOffset = -3;
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  return new Date(utc + 3600000 * brasilOffset);
}

// Data fixa para SSR — evita hydration mismatch
const SSR_DATE = new Date(2026, 4, 14);

export function getHojeSnapshot(): number {
  return getHojeBrasil().getTime();
}

export function getHojeServerSnapshot(): number {
  return SSR_DATE.getTime();
}

export function getInterpretacao(
  coeficiente: number,
  t: (key: string) => string
): { interpretacao: 'maré-alta' | 'maré-média' | 'maré-baixa'; label: string; badge: '🔴' | '🟡' | '🟢' } {
  if (coeficiente > 70) {
    return {
      interpretacao: 'maré-alta',
      label: t('widget.mare.altaLabel'),
      badge: '🔴',
    };
  }
  if (coeficiente >= 40) {
    return {
      interpretacao: 'maré-média',
      label: t('widget.mare.mediaLabel'),
      badge: '🟡',
    };
  }
  return {
    interpretacao: 'maré-baixa',
    label: t('widget.mare.baixaLabel'),
    badge: '🟢',
  };
}

export function getAnosDisponiveis(dados: DiaMare[]): number[] {
  const anos = new Set(dados.map(d => d.ano));
  return Array.from(anos).sort((a, b) => a - b);
}

export function getDiasVisiveis(
  dados: DiaMare[],
  mes: number,
  dia: number,
  ano: number
): DiaMare[] {
  const resultado: DiaMare[] = [];
  let diaAtual = dia;
  let mesAtual = mes;
  let anoAtual = ano;

  for (let i = 0; i < 4; i++) {
    const reg = dados.find(d => d.dia === diaAtual && d.mes === mesAtual && d.ano === anoAtual);
    if (reg) resultado.push(reg);

    const proximo = new Date(anoAtual, mesAtual - 1, diaAtual + 1);
    diaAtual = proximo.getDate();
    mesAtual = proximo.getMonth() + 1;
    anoAtual = proximo.getFullYear();
  }

  return resultado;
}

export function formatarData(dia: number, mes: number, _ano: number, t: (key: string) => string): string {
  const meses = [
    t('widget.mare.months.jan'),
    t('widget.mare.months.fev'),
    t('widget.mare.months.mar'),
    t('widget.mare.months.abr'),
    t('widget.mare.months.mai'),
    t('widget.mare.months.jun'),
    t('widget.mare.months.jul'),
    t('widget.mare.months.ago'),
    t('widget.mare.months.set'),
    t('widget.mare.months.out'),
    t('widget.mare.months.nov'),
    t('widget.mare.months.dez'),
  ];
  return `${dia} ${meses[mes - 1]}`;
}

export function interpretarDias(
  dias: DiaMare[],
  t: (key: string) => string
): DiaMareInterpretado[] {
  return dias.map(d => ({
    ...d,
    ...getInterpretacao(d.coeficiente, t),
  }));
}
